<template>
  <v-scale-transition>
    <div v-show="visible" class="message-image-dialog">
      <div class="message-image-dialog__toolbar">
        <v-tooltip class="ml-auto" bottom>
          <v-btn
            slot="activator"
            color="white"
            @click.stop="saveImage(chatMessageDto)"
            icon
            large
            flat>
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>下載</span>
        </v-tooltip>

        <v-tooltip bottom v-if="isTeacher">
          <v-btn
            @click="addImageToWhiteboard(chatMessageDto)"
            slot="activator"
            color="white"
            icon
            large
            flat>
            <v-icon>add_photo_alternate</v-icon>
          </v-btn>
          <span>加入白板</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            slot="activator"
            color="white"
            @click.stop="close"
            icon
            large
            flat>
            <v-icon>clear</v-icon>
          </v-btn>
          <span>關閉</span>
        </v-tooltip>
      </div>

      <div class="message-image-dialog__body">
        <img v-if="imageObjectUrl" class="message-image-dialog__image" :src="imageObjectUrl" />

        <chat-message-status
          v-else
          :percentage="percentage"
          :isFinished="isFinished"
          :isFailed="isFailed"
          :statusDesc="statusDesc"
          textColor="white" />
      </div>

      <div class="message-image-dialog__name">{{imageName}}</div>
    </div>
  </v-scale-transition>
</template>

<script>
import {mapActions} from 'vuex';
import chatMessageMxin from './ChatMessageMixin';
import ChatMessageStatus from './ChatMessageStatus';

export default {
  mixins: [chatMessageMxin],

  components: {
    'chat-message-status': ChatMessageStatus
  },

  data() {
    return {
      visible: false,
      imageObjectUrl: null,
      chatMessageDto: {}
    };
  },

  computed: {
    imageName() {
      return this.chatMessageDto.text || '';
    }
  },

  watch: {
    async isAttachmentReady(v) {
      if (v) {
        let blob = await this.chatMessageDto.GetAttachmentAsync();
        this.imageObjectUrl = URL.createObjectURL(blob);
      }
    }
  },

  mounted() {
    this._onWindowKeydown = this.onWindowKeydown.bind(this);
    window.addEventListener('keydown', this._onWindowKeydown);
  },

  beforeDestroy() {
    this.clear();
    window.removeEventListener('keydown', this._onWindowKeydown);
  },

  methods: {
    ...mapActions('alert', {
      addInfoAlert: 'addInfo'
    }),

    async open(chatMessageDto) {
      this.chatMessageDto = chatMessageDto;
      this.visible = true;
      await this.retriveAttachment(chatMessageDto);
    },

    close() {
      this.visible = false;
      this.clear();
    },

    clear() {
      URL.revokeObjectURL(this.imageObjectUrl);
      this.reset();
      this.imageObjectUrl = null;
      this.chatMessageDto = {};
    },

    onWindowKeydown(e) {
      if (this.visible && e.keyCode === 27) {
        this.close();
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.message-image-dialog {
  position: fixed;
  background-color: rgba(0, 0, 0, 1);
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  top: 0;
  left: 0;
}

.message-image-dialog__toolbar {
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 2rem 0 2rem;
  display: flex;
  background: linear-gradient(rgba(0,0,0,0.23), rgba(0,0,0,0.14), rgba(0,0,0,0.06), transparent);
}

.message-image-dialog__body {
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-image-dialog__image {
  max-width: 100vw;
  max-height: 100vh;
}

.message-image-dialog__name {
  position: absolute;
  text-align: center;
  bottom: 0;
  margin: auto;
  padding: 1rem;
  color: white;
  font-size: 1.3rem;
}
</style>